import { init } from '@sentry/browser';

init({
  dsn: 'https://de94a6dd0aa4471db6ddf1099a18a093@o137851.ingest.sentry.io/5272854',
});
